import script from "./ihbook_page01.vue?vue&type=script&setup=true&lang=js"
export * from "./ihbook_page01.vue?vue&type=script&setup=true&lang=js"

import "./ihbook_page01.vue?vue&type=style&index=0&id=3a22cd3c&scoped=true&lang=scss"

import exportComponent from "/opt/www/novasector.net/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a22cd3c"]])

export default __exports__